import React, { Component, Fragment } from "react";

import "./ItemCard.css";
import no_image_img from "../../no-image.png";
import { toPersianNumber } from "../../classes/utils";

import withRouter from "../withRouter/withRouter";

class ItemCard extends Component {
    constructor(props) {
        super(props);
        this.no_image = { url: no_image_img };
    }

    state = {};
    render() {
        let { item, selected } = this.props;
        let {
            medias,
            name,
            is_special_offer,
            colors,
            retail_price,
            special_offer_discount,
            retail_discount,
            step,
        } = item;
        let hasDiscount =
            (is_special_offer && special_offer_discount) || retail_discount;

        return (
            <Fragment>
                {item && (
                    <div
                        className={
                            "ItemCardContainer " + (selected ? "selected" : "")
                        }
                        onClick={(ev) => {
                            this.props.router.navigate("/item/" + item.id);
                        }}
                    >
                        <div className='image'>
                            <img
                                src={
                                    (
                                        medias.find((m) => {
                                            return m.type === "image";
                                        }) || this.no_image
                                    ).url
                                }
                                loading='lazy'
                            />
                        </div>

                        {is_special_offer && (
                            <div className='isSpecialOffer'>فروش ویژه</div>
                        )}

                        <h1 className='name'>{name}</h1>
                        {retail_price &&
                        step <=
                            colors
                                .map((c) => {
                                    return parseInt(c.available_amount) || 0;
                                })
                                .reduce((a, b) => {
                                    return a + b;
                                }, 0) ? (
                            <div className='price'>
                                {hasDiscount ? (
                                    <div className='discount'>
                                        <h3 className='disountPercent'>
                                            {toPersianNumber(
                                                parseInt(
                                                    (((parseInt(
                                                        special_offer_discount,
                                                    ) || 0) +
                                                        (parseInt(
                                                            retail_discount,
                                                        ) || 0)) /
                                                        parseInt(
                                                            retail_price,
                                                        )) *
                                                        100,
                                                ),
                                            )}
                                            %<span>{"   تخفیف    "}</span>
                                        </h3>
                                        <h3 className='beforeDiscount'>
                                            {toPersianNumber(
                                                retail_price,
                                                true,
                                            )}
                                            <span>تومان</span>
                                        </h3>
                                    </div>
                                ) : (
                                    <div className='invisible'></div>
                                )}

                                <h2 className='final'>
                                    {toPersianNumber(
                                        hasDiscount
                                            ? retail_price -
                                                  (is_special_offer
                                                      ? parseInt(
                                                            special_offer_discount,
                                                        ) || 0
                                                      : 0 +
                                                        (parseInt(
                                                            retail_discount,
                                                        ) || 0))
                                            : retail_price,
                                        true,
                                    )}
                                    <span>تومان</span>
                                </h2>
                            </div>
                        ) : (
                            <h2 className=' text danger not_available'>
                                نا موجود
                            </h2>
                        )}

                        <div className='colors'>
                            {colors &&
                                colors.length > 0 &&
                                colors.map((color) => {
                                    return (
                                        color.available_amount > 0 && (
                                            <div
                                                className='color'
                                                style={{
                                                    backgroundColor:
                                                        color.color.color,
                                                }}
                                                key={color.color.color}
                                            ></div>
                                        )
                                    );
                                })}
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default withRouter(ItemCard);
